__turbopack_context__.v({
  "card": "Tips-module-scss-module__Pcdima__card",
  "close-button": "Tips-module-scss-module__Pcdima__close-button",
  "expand-button": "Tips-module-scss-module__Pcdima__expand-button",
  "focus-wrapper": "Tips-module-scss-module__Pcdima__focus-wrapper",
  "footer": "Tips-module-scss-module__Pcdima__footer",
  "header": "Tips-module-scss-module__Pcdima__header",
  "icon": "Tips-module-scss-module__Pcdima__icon",
  "is-in-view": "Tips-module-scss-module__Pcdima__is-in-view",
  "is-selected": "Tips-module-scss-module__Pcdima__is-selected",
  "panel-dot": "Tips-module-scss-module__Pcdima__panel-dot",
  "summary": "Tips-module-scss-module__Pcdima__summary",
  "tip": "Tips-module-scss-module__Pcdima__tip",
  "tip-carousel": "Tips-module-scss-module__Pcdima__tip-carousel",
  "tip-switcher": "Tips-module-scss-module__Pcdima__tip-switcher",
  "wrapper": "Tips-module-scss-module__Pcdima__wrapper",
});
